// The live chat API refuses a message whose text is longer than this
// (services-sure: live_chat_access.MAX_MESSAGE_TEXT_LENGTH), so keep the two in step.
// The browser counts an emoji as two characters where the API counts one, so the
// widget never sends more than the API takes.
export const MAX_MESSAGE_TEXT_LENGTH = 2048;

export const fitsMessageText = (text) =>
  typeof text === 'string' && text.length <= MAX_MESSAGE_TEXT_LENGTH;
